import type { ReactElement } from "react"
import DomainSearchModal from "../DomainSearchModal"
import PlanOverLimitModal from "../PlanOverLimitModal"

export default function ModalHandler(): ReactElement {
  return (
    <>
      <DomainSearchModal />

      <PlanOverLimitModal />
    </>
  )
}
